import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hrAndMin'
})
export class HoursAndMinutesPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    if (isNaN(value) || !(+value)) {
      return value;
    }
    const hours = Math.floor((+value) / 60);
    const minutes = Math.floor((+value) % 60)
    const time = [];
    if (hours) {
      time.push(`${hours} Hr${+hours>1? 's': ''}`);
    }
    if (minutes) {
      time.push(`${minutes} Min${+minutes>1? 's': ''}`)
    }
    return time.join(' ');
  }

}
